/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from "jquery";
import prestashop from "prestashop";
function setUpCheckout() {
  $(".js-terms a").on("click", (event) => {
    event.preventDefault();
    var url = $(event.target).attr("href");
    if (url) {
      url += `?content_only=1`;
      $.get(url, (content) => {
        $("#modal").find(".js-modal-content").html($(content).find(".page-content--cms").contents());
      }).fail((resp) => {
        prestashop.emit("handleError", {eventType: "clickTerms", resp});
      });
    }
    $("#modal").modal("show");
  });
  $(".js-gift-checkbox").on("click", (event) => {
    $("#gift").collapse("toggle");
  });
}
$(() => {
  if ($("body#checkout").length === 1) {
    setUpCheckout();
  }
  $(document).on("change", ".js-input-delivery:checked", ({currentTarget}) => {
    $(".js-label-delivery.selected").removeClass("selected");
    $(currentTarget).closest(".js-label-delivery").addClass("selected");
  });
  $(document).on("change", '.js-checkout-payment-method [name="payment-option"]:checked', ({currentTarget}) => {
    $(".js-checkout-payment-method.selected").removeClass("selected");
    $(currentTarget).closest(".js-checkout-payment-method").addClass("selected");
  });
  prestashop.on("updatedDeliveryForm", (params) => {
    if (typeof params.deliveryOption === "undefined" || params.deliveryOption.length === 0) {
      return;
    }
    $(".carrier-extra-content").hide();
    params.deliveryOption.next(".carrier-extra-content").slideDown();
  });
  prestashop.on("changedCheckoutStep", (params) => {
    if (typeof params.event.currentTarget !== "undefined") {
      const $target = $(params.event.currentTarget);
      if (!$target.hasClass("-unreachable")) {
        $(".collapse", params.event.currentTarget).not(".show").not(".collapse .collapse").collapse("show");
      }
    }
  });
});
if (module.hot) { module.hot.accept(); }